import React from 'react';
import { motion } from 'framer-motion';
export function FadeIn({
  children,
  delay = 0
}: {
  children: ReactNode;
  delay?: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} data-id="element-188">
      {children}
    </motion.div>;
}